/* eslint-disable import/prefer-default-export */
import {gql as runTimeGQL, useQuery} from '@apollo/client';

const VIEWER_QUERY = runTimeGQL`
query ViewerQuery {
  viewer {
    id
    databaseId
    firstName
    email
  }
}
`;

const useViewer = (fetchPolicy = 'cache-first') => {
  const isSSR = typeof window === 'undefined';
  if (isSSR) return {loading: false, data: {}, viewerIs: {}};

  const queryResult = useQuery(VIEWER_QUERY, {fetchPolicy});

  const email = queryResult?.data?.viewer?.email;
  const isLoggedIn = !!email;
  const isStaff = email?.endsWith('@makeschool.com') || email?.endsWith('@makeschool.org');
  const isStudent =
    email?.endsWith('@students.makeschool.com') || email?.endsWith('@students.makeschool.org');

  return {...queryResult, viewerIs: {isLoggedIn, isStaff, isStudent}};
};

export {useViewer};
